// extracted by mini-css-extract-plugin
export var arrow_icon = "index-module--arrow_icon--daab4";
export var icon = "index-module--icon--fa62f";
export var lng_link_item = "index-module--lng_link_item--e75df";
export var other_lng_link_wrapper = "index-module--other_lng_link_wrapper--6bd4d";
export var trigger_btn = "index-module--trigger_btn--52b5c";
export var wrapper = "index-module--wrapper--1c77a";